export default __webpack_public_path__ + "static/solo-drop-green-152f7867e2ca3359841d682361fc86ee.gif";